import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import produce from 'immer';
import ACTIONS from '../../actions';
import getDotProp from '../../../utils/getDotProp';
var initialState = {};

var getNextStateBasedOnActionView = function getNextStateBasedOnActionView(state, actionView) {
  var id = actionView.id,
      dataKey = actionView.dataKey,
      idKeyProp = actionView.idKeyProp,
      url = actionView.url,
      mode = actionView.mode,
      page = actionView.page,
      itemsPerPage = actionView.itemsPerPage,
      sort = actionView.sort,
      by = actionView.by,
      filter = actionView.filter,
      all = actionView.all,
      isLoading = actionView.isLoading,
      fullyLoaded = actionView.fullyLoaded,
      startedLoadingAt = actionView.startedLoadingAt,
      lastLoadingTook = actionView.lastLoadingTook;
  var nextState = produce(state, function (draft) {
    draft[id] = draft[id] || {};
    draft[id].id = id;
    if (typeof idKeyProp !== 'undefined') draft[id].idKeyProp = idKeyProp;
    if (typeof dataKey !== 'undefined') draft[id].dataKey = dataKey;
    if (typeof url !== 'undefined') draft[id].url = url;
    if (typeof mode !== 'undefined') draft[id].mode = mode;
    if (typeof page !== 'undefined') draft[id].page = page;
    if (typeof itemsPerPage !== 'undefined') draft[id].itemsPerPage = itemsPerPage;
    if (typeof sort !== 'undefined') draft[id].sort = sort;
    if (typeof by !== 'undefined') draft[id].by = by;
    if (typeof filter !== 'undefined') draft[id].filter = filter;
    if (typeof all !== 'undefined') draft[id].all = all;
    if (typeof isLoading !== 'undefined') draft[id].isLoading = isLoading;
    if (typeof fullyLoaded !== 'undefined') draft[id].fullyLoaded = fullyLoaded;
    if (typeof startedLoadingAt !== 'undefined') draft[id].startedLoadingAt = startedLoadingAt;
    if (typeof lastLoadingTook !== 'undefined') draft[id].lastLoadingTook = lastLoadingTook;
  });
  return nextState;
};

export var viewsReducer = function viewsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ACTIONS.GRID_VIEW_SET:
    case ACTIONS.GRID_DATA_GET:
      {
        return getNextStateBasedOnActionView(state, action.view);
      }

    case ACTIONS.GRID_DATA_GET_RESOLVED:
      {
        var _action$view = action.view,
            id = _action$view.id,
            idKeyProp = _action$view.idKeyProp,
            filter = _action$view.filter;
        var _action$payload = action.payload,
            TotalCount = _action$payload.TotalCount,
            Data = _action$payload.Data;
        var start = action.sliceRange.start; //skip if it's not reflecting the current state

        if (filter !== state[id].filter) return state;
        var nextState = produce(state, function (draft) {
          draft[id] = draft[id] || {};
          draft[id].count = TotalCount;
          draft[id].all = draft[id].all || {};
          Data.map(function (item, idx) {
            draft[id].all[start + idx] = getDotProp(item, idKeyProp);
          });
          draft[id].error = null;
        });
        return getNextStateBasedOnActionView(nextState, _objectSpread({}, action.view, {
          page: undefined,
          filter: undefined,
          sort: undefined,
          by: undefined
        }));
      }

    case ACTIONS.GRID_DATA_GET_FAILED:
      {
        var _action$payload2 = action.payload,
            error = _action$payload2.error,
            text = _action$payload2.text;
        var _id = action.view.id;
        if (!error) return state;

        var _nextState = produce(state, function (draft) {
          draft[_id].error = {
            error: error,
            text: text
          };
        });

        return getNextStateBasedOnActionView(_nextState, action.view);
      }

    default:
      return state;
  }
};
export default viewsReducer;